import VODCategory from './VODCategory';

export default VODCategory;